import React from 'react'

import PropTypes from 'prop-types'

import useStyles from './reference-bubble.style'

const ReferenceBubble = props => {
  const classes = useStyles(props)

  const { children, children: { props: { message: { collection } } } } = props

  switch (collection) {
  case 'custom-v1':
    return children
  case 'noaa-v1':
  case 'panicbutton-v1':
  case 'priority-connect':
  case 'searchlight-v2':
    return children
  case 'tip-v1':
    return children
  case 'safe-walk-v1':
    return children
  default:
    return <div className={classes.bubble}>{children}</div>
  }
}

ReferenceBubble.propTypes = {
  children: PropTypes.node.isRequired,
  isMe: PropTypes.bool.isRequired
}

export default ReferenceBubble
